import React from 'react';
import { Grid, Card, CardContent, Typography, Box } from '@mui/material';
import { tips as kitchenTips } from './KitchenTips';
import { tips as bathroomTips } from './BathroomTips';
import { tips as livingRoomTips } from './LivingRoomTips';
import { tips as bedroomTips } from './BedroomTips';
import { tips as seasonalTips } from './SeasonalTips';
import { tips as productTips } from './ProductTips';

const categories = [
  { name: "Kitchen", icon: "🍳", count: kitchenTips.length, color: "#ff6b6b", image: "/images/cleaning-hero.jpg" },
  { name: "Bathroom", icon: "🚿", count: bathroomTips.length, color: "#4ecdc4", image: "/images/quotation-hero.png" },
  { name: "Living Room", icon: "🛋️", count: livingRoomTips.length, color: "#45b7d1", image: "/images/cleaning-hero.jpg" },
  { name: "Bedroom", icon: "🛏️", count: bedroomTips.length, color: "#96ceb4", image: "/images/quotation-hero.png" },
  { name: "Seasonal", icon: "🍂", count: seasonalTips.length, color: "#feca57", image: "/images/cleaning-hero.jpg" },
  { name: "Products", icon: "🧽", count: productTips.length, color: "#ff9ff3", image: "/images/quotation-hero.png" }
];

const CategoryCard = ({ name, icon, count, color, image }) => (
  <Card sx={{ 
    color: 'white', 
    textAlign: 'center', 
    height: '150px', 
    display: 'flex', 
    flexDirection: 'column', 
    justifyContent: 'center', 
    alignItems: 'center',
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${image})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    transition: 'transform 0.3s',
    '&:hover': {
      transform: 'scale(1.05)'
    }
  }}>
    <CardContent>
      <Typography variant="h2">{icon}</Typography>
      <Typography variant="h5">{name}</Typography>
      <Typography variant="body1">{count} tips</Typography>
    </CardContent>
  </Card>
);

const CategoryNavigation = ({ onSelectCategory }) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Grid container spacing={3}>
        {categories.map(category => (
          <Grid item xs={12} sm={6} md={4} lg={2} key={category.name}>
            <div onClick={() => onSelectCategory && onSelectCategory(category.name)} style={{ cursor: 'pointer' }}>
              <CategoryCard {...category} />
            </div>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default CategoryNavigation;
